export default "__VITE_ASSET__DSu9PApK__"